import React from 'react';
import { Button, Typography } from 'antd';
import { LockOutlined, CheckCircleOutlined, RocketOutlined, RightOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import './SubscriptionLockOverlay.css';

const { Title, Text } = Typography;

const FEATURES = [
  'AI Buy Signals',
  'Competitive Price Ranking',
  'Unlimited VIN Analyses',
  'Market Intelligence Dashboard',
];

/**
 * Centered "Access Paused" modal – Hooptie premium style (cosmic/grain card, purple glow, green CTA).
 */
function SubscriptionLockOverlay({ onReactivate }) {
  const history = useHistory();

  const handleReactivate = () => {
    if (typeof onReactivate === 'function') {
      onReactivate();
    } else {
      history.push('/billing');
    }
  };

  const handleContactSupport = () => {
    history.push('/support');
  };

  return (
    <div className="subscription-lock-overlay">
      <div className="subscription-lock-modal">
        {/* Top icon: lock in 72px circle with glow */}
        <div className="subscription-lock-modal-icon-circle">
          <LockOutlined className="subscription-lock-modal-icon" />
        </div>

        <Title level={2} className="subscription-lock-modal-title">
          Access Paused
        </Title>
        <Text className="subscription-lock-modal-subtitle">
          Your Hooptie Elite subscription has ended.
        </Text>

        <ul className="subscription-lock-modal-features">
          {FEATURES.map((label) => (
            <li key={label}>
              <span className="subscription-lock-modal-check-circle">
                <CheckCircleOutlined className="subscription-lock-modal-check" />
              </span>
              <span>{label}</span>
            </li>
          ))}
        </ul>

        <Button
          type="primary"
          size="large"
          className="subscription-lock-modal-btn"
          icon={<RocketOutlined className="subscription-lock-modal-btn-icon" />}
          onClick={handleReactivate}
        >
          Reactivate Hooptie Elite
        </Button>

        <button
          type="button"
          className="subscription-lock-modal-support-link"
          onClick={handleContactSupport}
        >
          Contact Support <RightOutlined />
        </button>
      </div>
    </div>
  );
}

export default SubscriptionLockOverlay;
